<template>
  <div>
    <v-row>
      <v-col cols="12" md='12' class="d-flex justify-center mt-4">
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          :href="icon.link"
          class="mt-1"
          color="greyTint"
          icon>
          <v-icon size="22px">{{ icon.icon }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md='12' class="d-flex justify-center">
        <div class="p-0 m-0">
          <i>{{ $t('general.slogan') }}.</i>
        </div>
      </v-col>
      <v-col cols="12" md='12' class="d-flex justify-center">
        <div class="primary--text">
          {{ new Date().getFullYear() }} &copy; {{ $t('general.signal') }}<i>{{ $t('general.view') }}</i> - {{ $t('general.copyright') }}.
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import config from '../../config';

  export default {
    name: 'Footer',
    data: () => ({
      config,
      icons: [
        {icon: 'mdi-facebook', link: 'https://www.facebook.com/'},
        {icon: 'mdi-instagram', link: 'https://www.instagram.com/'},
        {icon: 'mdi-twitter', link: 'https://x.com/'},
      ],
    })
  };
</script>
